module.exports = __webpack_public_path__ + "img/logo5.e60188b2.png";